import { Button as AntdButton, Input, message } from "antd";
import React from "react";
import styled from "styled-components";
import { IconCopy, IconSuccess } from "../../../assets/icons";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const TitleText = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: #1e1e1e;
  text-align: center;
`;

const Text = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #7a7a7a;
  text-align: center;
`;
const Card = styled.div`
  width: 520px;
  margin: 0 auto;
  padding: 50px;
  margin: 24px auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 16px;
  border: 1px solid #eaeaea;
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.1);
`;

const Button = styled(AntdButton)`
  width: 100%;
  height: 48px;
  background-color: #1677ff;
  color: #fff !important;
  font-weight: 600;
  font-size: 16px;
  border-radius: 8px;
`;

const PaymentSuccessful = ({ store,orderId }) => {

  const {t} = useTranslation();

  const handleCopy = () => {
    navigator.clipboard
      .writeText(store)
      .then(() => {
        message.success(t('copy_to'));
      })
      .catch(() => {
        message.error("Failed to copy!");
      });
  };

  const navigate = useNavigate();

  const handleOrderDetailsPage = () => {
    navigate(`/home/orderDetails/${orderId}`);
  }


  return (
    <div style={{ height: "70vh", display: "flex", alignItems: "center" }}>
      <Card>
        <TitleText
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize:"22px",
            fontWeight:"600",
            gap: 8,
          }}
        >
          <IconSuccess style={{ width: "32px" }} /> {t('payment_success')}
        </TitleText>
        <Text>
          {t('you_store_on_web')}
        </Text>

        <Input
          value={store}
          readOnly
          style={{ backgroundColor: "#f5f5f5", color: "#1677ff" }}
          suffix={
            <span onClick={handleCopy} style={{ cursor: "pointer" }}>
              <IconCopy />
            </span>
          }
        />
        <Button type="primary" onClick={handleOrderDetailsPage}>{t('order_details')}</Button>
      </Card>
    </div>
  );
};

export default PaymentSuccessful;
